import React from "react";

function CrownIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1508 3.15198C11.1925 3.07638 11.2536 3.01333 11.3279 2.96942C11.4022 2.92551 11.4869 2.90234 11.5732 2.90234C11.6596 2.90234 11.7443 2.92551 11.8186 2.96942C11.8929 3.01333 11.954 3.07638 11.9957 3.15198L14.8427 8.55663C14.9105 8.68178 15.0053 8.79034 15.1201 8.87452C15.235 8.95871 15.367 9.01642 15.5068 9.04353C15.6465 9.07063 15.7906 9.06646 15.9285 9.0313C16.0665 8.99614 16.195 8.93087 16.3047 8.84017L20.4296 5.30651C20.5088 5.24211 20.6063 5.20449 20.7083 5.19907C20.8102 5.19366 20.9112 5.22072 20.9968 5.27637C21.0823 5.33202 21.148 5.41338 21.1844 5.50874C21.2208 5.6041 21.226 5.70855 21.1992 5.80705L18.466 15.6886C18.4102 15.8908 18.29 16.0693 18.1236 16.197C17.9573 16.3248 17.7538 16.3948 17.544 16.3965H5.60345C5.39352 16.395 5.18981 16.3251 5.02324 16.1973C4.85667 16.0696 4.73633 15.8909 4.68049 15.6886L1.94827 5.80801C1.92151 5.70952 1.92669 5.60507 1.96306 5.50971C1.99944 5.41434 2.06514 5.33298 2.1507 5.27733C2.23626 5.22168 2.33728 5.19462 2.4392 5.20004C2.54112 5.20545 2.6387 5.24307 2.71788 5.30747L6.84177 8.84113C6.95152 8.93183 7.07999 8.9971 7.21796 9.03226C7.35593 9.06742 7.49997 9.0716 7.63974 9.04449C7.77951 9.01739 7.91155 8.95967 8.02637 8.87549C8.14119 8.7913 8.23595 8.68274 8.30384 8.55759L11.1508 3.15198Z"
        stroke="#424242"
        strokeWidth="1.92885"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.82214 20.2539H18.3241"
        stroke="#424242"
        strokeWidth="1.92885"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default CrownIcon;
